import React, { useEffect, useState } from "react";
import { getTransactions } from "../../services/transactionService";
import Loader from "../../components/Loader";

function Transactions() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTransactions()
      .then(data => setTransactions(data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loader />;

  return (
    <div>
      <h2>Transactions</h2>
      <ul>
        {transactions.map(t => (
          <li key={t.id}>{t.amount} {t.currency} - {t.date}</li>
        ))}
      </ul>
    </div>
  );
}

export default Transactions;
